import React, { Component } from 'react';


const OutstandingAmount = ({ message }) => {

    let response = JSON.parse(message);
    let payment_due_date, outstanding_amount


    if (response && Object.keys(response) && Object.keys(response).length > 0 && Object.keys(response).includes('Payment Due Date' || 'Outstanding Amount' || 'Bill Amount' || 'Next Bill Date')) {

        Object.keys(response).map((key) => {
            // console.log(key)
            switch (key) {
                case 'Next Bill Date':
                    payment_due_date = response[key]
                    break;
                case 'Payment Due Date':
                    payment_due_date = response[key]
                    break;
                case 'Bill Amount':
                    outstanding_amount = response[key]
                    break;
                case 'Outstanding Amount':
                    outstanding_amount = response[key]
                    break;
            }
        })
    }

    else {
        response && response.map(key => {
            switch (key.tagName) {
                case 'Payment Due Date':
                    payment_due_date = key.informationDisplayValue
                    break;
                case 'Next Bill Date':
                    payment_due_date = key.informationDisplayValue
                    break;
                case 'Bill Amount':
                    outstanding_amount = key.informationDisplayValue
                    break;
                case 'Outstanding Amount':
                    outstanding_amount = key.informationDisplayValue
                    break;
            }
        })
    }
    return (
        <div >
            <div className="mr-10 " style={{ marginLeft: '60px', overflow: 'auto' }}>
                <div className="rental-plan text-left pt-30 width-full pb-30 data_balance_new">
                    <div className="outstanding-amount">
                        <div className='fs-10 pb-5'><span>OUTSTANDING AMOUNT</span></div>
                        <div className='pb-15'><span className='fs-30'>Rs. {outstanding_amount && outstanding_amount}</span></div>
                        <div><span className='fs-10 opacity-6'>DUE DATE: {payment_due_date && payment_due_date}</span></div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default OutstandingAmount;


// WEBPACK FOOTER //
// ./src/components/message-components/outstanding-amount.component.js